import React from 'react';
import Events from '../../components/events/events';
import { useGetEventsQuery } from '../../services/store/api/eventsApi';
import Loader from '../../components/loader/loader';
export function EventsPage() {

    const { data, isLoading, error } = useGetEventsQuery();

    const events = data?.events;

    if (isLoading) return <Loader />;
    if (error) return <div>Ошибка загрузки событий</div>;

    return (
        <>
            {events && <Events events={events} />}
        </>
    );
}